(function () {
  const WARNING = {
    title: "⚠️ Dikkat",
    text:
      "📵 Telefonu *Kayıtsız* olarak sipariş vermek üzeresiniz.\n\n" +
      "⏳ Bu şekilde alırsanız devletin belirlediği yılda *4 + 4 ay* olmak üzere toplam *8 ay* kullanabilirsiniz.\n" +
      "🔄 Her yıl başında kullanım süreniz sıfırlanır.\n\n" +
      "✅ Üründe kayıt seçeneği varsa *kayıtlı* olarak alabilirsiniz.\n\n" +
      "👉 Devam etmek istiyor musunuz?",
    cancel: "Vazgeç",
    ok: "Kayıtsız Aldığımın Farkındayım Sepete Ekle"
  };

  // ---- helpers ----
  const isKayitsiz = (t) =>
    (t || "")
      .toString()
      .toLowerCase()
      .replace(/ı/g, "i")
      .includes("kayitsiz");

  function getVariantIdFromDOM() {
    // Shopify ürün formunda çoğunlukla name="id" inputu olur
    const idInput =
      document.querySelector('form[action*="/cart/add"] input[name="id"]') ||
      document.querySelector('input[name="id"][value]');
    return idInput ? idInput.value : null;
  }

  function getProductFormRoot() {
    return (
      document.querySelector('form.js-product-form-main') ||
      document.querySelector('form.js-product-form') ||
      document.querySelector('.cc-main-product') ||
      document.querySelector('.js-product')
    );
  }

  function isKayitsizFromDOM(root) {
    const scope = root || getProductFormRoot();
    if (!scope) return false;

    const selects = scope.querySelectorAll('select[name^="options"], select[data-option]');
    for (const s of selects) {
      const opt = s?.selectedOptions?.[0];
      const text = opt?.textContent?.trim() || "";
      if (isKayitsiz(text)) return true;
    }

    const checkedRadios = scope.querySelectorAll('input[type="radio"]:checked');
    for (const r of checkedRadios) {
      const label = scope.querySelector(`label[for="${r.id}"]`) || document.querySelector(`label[for="${r.id}"]`);
      const labelText = label?.textContent?.trim() || "";
      if (isKayitsiz(labelText) || isKayitsiz(r.value)) return true;
    }

    return false;
  }

  async function isKayitsizByVariantId(variantId) {
    try {
      const handle = window.location.pathname.split("/products/")[1]?.split(/[/?#]/)[0];
      if (!handle) return false;

      const res = await fetch(`/products/${handle}.js`, { cache: "no-store" });
      if (!res.ok) return false;
      const product = await res.json();

      const v = (product.variants || []).find((x) => String(x.id) === String(variantId));
      if (!v) return false;

      return [v.option1, v.option2, v.option3, v.title].some(isKayitsiz);
    } catch {
      return false;
    }
  }

  async function shouldWarn(variantId) {
    if (isKayitsizFromDOM()) return true;
    if (variantId) return await isKayitsizByVariantId(variantId);
    return false;
  }
  function ensureModalStyles() {
    if (document.getElementById("tm-kayitsiz-style")) return;

    const style = document.createElement("style");
    style.id = "tm-kayitsiz-style";
    style.textContent = `
      .tm-kayitsiz-overlay{
        position:fixed; inset:0; background:rgba(0,0,0,.55);
        display:flex; align-items:center; justify-content:center;
        z-index:999999;
        padding:16px;
      }
      .tm-kayitsiz-modal{
        width:min(560px, 100%);
        background:#fff;
        border-radius:16px;
        box-shadow:0 20px 60px rgba(0,0,0,.25);
        overflow:hidden;
        font-family:system-ui,-apple-system,Segoe UI,Roboto,Arial;
      }
      .tm-kayitsiz-head{
        padding:16px 18px;
        border-bottom:1px solid rgba(0,0,0,.08);
        font-weight:800;
        font-size:16px;
      }
      .tm-kayitsiz-body{
        padding:16px 18px;
        line-height:1.55;
        white-space:pre-line;
        color:#111;
        font-size:14px;
      }
      .tm-kayitsiz-body b{ font-weight:800; }
      .tm-kayitsiz-actions{
        padding:14px 18px 18px;
        display:flex;
        gap:10px;
        justify-content:flex-end;
      }
      .tm-btn{
        border-radius:12px;
        padding:10px 14px;
        font-size:14px;
        cursor:pointer;
        border:1px solid rgba(0,0,0,.14);
        background:#fff;
      }
      .tm-btn-primary{
        border-color:transparent;
        background:#111;
        color:#fff;
      }
      .tm-btn:active{ transform:translateY(1px); }
    `;
    document.head.appendChild(style);
  }

  function escapeHtml(str) {
    return (str || "").replace(/[&<>"']/g, (m) => ({
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#039;"
    }[m]));
  }

  function formatTextToHTML(text) {
    const escaped = escapeHtml(text);
    return escaped.replace(/\*(.+?)\*/g, "<b>$1</b>");
  }

  let modalOpen = false;
  function showKayitsizModal() {
    if (modalOpen) return Promise.resolve(false);
    modalOpen = true;

    ensureModalStyles();

    return new Promise((resolve) => {
      const overlay = document.createElement("div");
      overlay.className = "tm-kayitsiz-overlay";
      overlay.setAttribute("role", "dialog");
      overlay.setAttribute("aria-modal", "true");

      const modal = document.createElement("div");
      modal.className = "tm-kayitsiz-modal";

      modal.innerHTML = `
        <div class="tm-kayitsiz-head">${escapeHtml(WARNING.title)}</div>
        <div class="tm-kayitsiz-body">${formatTextToHTML(WARNING.text)}</div>
        <div class="tm-kayitsiz-actions">
          <button type="button" class="tm-btn tm-btn-cancel">${escapeHtml(WARNING.cancel)}</button>
          <button type="button" class="tm-btn tm-btn-primary tm-btn-ok">${escapeHtml(WARNING.ok)}</button>
        </div>
      `;

      overlay.appendChild(modal);
      document.body.appendChild(overlay);

      const close = (val) => {
        modalOpen = false;
        overlay.remove();
        resolve(val);
      };

      overlay.addEventListener("click", (e) => {
        if (e.target === overlay) close(false);
      });

      function onKey(e) {
        if (e.key === "Escape") {
          document.removeEventListener("keydown", onKey);
          close(false);
        }
      }
      document.addEventListener("keydown", onKey);

      overlay.querySelector(".tm-btn-cancel").addEventListener("click", () => {
        document.removeEventListener("keydown", onKey);
        close(false);
      });
      overlay.querySelector(".tm-btn-ok").addEventListener("click", () => {
        document.removeEventListener("keydown", onKey);
        close(true);
      });
    });
  }

  // ---- 1) fetch: /cart/add + /checkout yakala ----
  const originalFetch = window.fetch;
  window.fetch = async function (input, init) {
    const url = typeof input === "string" ? input : (input && input.url) || "";

    const isAddToCart = url.includes("/cart/add") || url.includes("/cart/add.js");
    const isCheckout = url.includes("/checkout");

    // add-to-cart isteği: variantId yakala ve uyar
    if (isAddToCart) {
      let variantId = null;
      try {
        const body = init && init.body;

        if (body && typeof FormData !== "undefined" && body instanceof FormData) {
          variantId = body.get("id");
        }

        if (!variantId && typeof body === "string") {
          const params = new URLSearchParams(body);
          variantId = params.get("id");
        }
      } catch {}

      const warn = await shouldWarn(variantId || getVariantIdFromDOM());
      if (warn) {
        const ok = await showKayitsizModal();
        if (!ok) return Promise.reject(new Error("Kayıtsız uyarısı: kullanıcı vazgeçti."));
      }
      return originalFetch.apply(this, arguments);
    }

    // checkout isteği: bazı temalarda buy-now direkt checkout’a gider.
    // Eğer kayıtsız ise checkout'u da durdur.
    if (isCheckout) {
      const warn = await shouldWarn(getVariantIdFromDOM());
      if (warn) {
        const ok = await showKayitsizModal();
        if (!ok) return Promise.reject(new Error("Kayıtsız uyarısı: checkout engellendi."));
      }
      return originalFetch.apply(this, arguments);
    }

    return originalFetch.apply(this, arguments);
  };

  // ---- 2) XHR: /cart/add & /checkout yakala (bazı temalar fetch kullanmaz) ----
  const originalOpen = XMLHttpRequest.prototype.open;
  const originalSend = XMLHttpRequest.prototype.send;

  XMLHttpRequest.prototype.open = function (method, url) {
    this.__tm_url = url;
    return originalOpen.apply(this, arguments);
  };

  XMLHttpRequest.prototype.send = function (body) {
    const url = this.__tm_url || "";
    const isAddToCart = url.includes("/cart/add") || url.includes("/cart/add.js");
    const isCheckout = url.includes("/checkout");

    if (!isAddToCart && !isCheckout) {
      return originalSend.apply(this, arguments);
    }

    (async () => {
      let variantId = null;

      if (isAddToCart) {
        try {
          if (typeof body === "string") {
            const params = new URLSearchParams(body);
            variantId = params.get("id");
          }
        } catch {}
      }

      const warn = await shouldWarn(variantId || getVariantIdFromDOM());
      if (warn) {
        const ok = await showKayitsizModal();
        if (!ok) return; // gönderme = sepete ekle / checkout iptal
      }

      originalSend.apply(this, arguments);
    })();
  };

  // ---- 3) “Hemen satın al” / dinamik ödeme butonlarını yakala ----
  // Shopify dynamic checkout: .shopify-payment-button__button
  // Buy now bazı temalarda: [name="checkout"], [data-buy-now], .buy-now, .product-form__submit (ikinci buton)
  document.addEventListener(
    "click",
    async function (e) {
      const el = e.target && e.target.closest
        ? e.target.closest(
            ".shopify-payment-button__button, [name='checkout'], [data-buy-now], .buy-now, button[data-testid='Checkout-button'], a[href*='/checkout']"
          )
        : null;

      if (!el) return;

      const warn = await shouldWarn(getVariantIdFromDOM());
      if (warn) {
        const ok = await showKayitsizModal();
        if (!ok) {
          e.preventDefault();
          e.stopImmediatePropagation();
          return false;
        }
      }
    },
    true
  );
})();
